export const Radio = ({ register, id, label, name, value }) => {
  return (
    <div className="flex items-center">
      <input {...register(`${name}`)} id={id} type="radio" value={value} />
      <label htmlFor={id} className="pl-6 md:pl-10">
        {label}
      </label>
    </div>
  )
}
